export function initHeader() {
    const header = document.querySelector('.site-header');
    const searchIcon = document.querySelector('.icon--search') as HTMLElement;

    if (!header) return;

    const body = document.body;
    if (body.classList.contains('landing-page-tree')) {
        return;
    }

    //const hasHeroMedia = document.querySelector('.hero-block-video, .hero-block-picture, .cover-block-picture');
    //if (!hasHeroMedia) {
    //    console.log("No hero media found");
    //    header.classList.add('scrolled');
    //} else {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });
    //}


}